import { useSelector } from 'react-redux';

import { UNIQUE_PROMO_ID_QUERY_PARAM_CONFIG_KEY } from '../../../constants/config';
import { selectPage } from '../../../selectors/analytics';
import { IPromoNewbuildingLink } from '../../../types/promos/newbuildingLink';
import { IPromoDetails } from '../../../types/promos/promoDetails';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getNewbuildingPromosAnchor } from '../../../utils/url';

export const useNewbuildingLinks = (promoDetails: IPromoDetails | null): IPromoNewbuildingLink[] => {
  const { config } = useApplicationContext();
  const { siteType } = useSelector(selectPage);

  if (!promoDetails) {
    return [];
  }

  const uniquePromoIdParam = config.get<string>(UNIQUE_PROMO_ID_QUERY_PARAM_CONFIG_KEY) ?? 'uniquePromoId';

  return promoDetails.newbuildingLinks.map(link => ({
    ...link,
    url: `${link.url}?${uniquePromoIdParam}=${promoDetails.uniquePromoId}${getNewbuildingPromosAnchor(siteType)}`,
  }));
};
